import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { WalletProvider, useWallet } from "./contexts/WalletContext";
import Layout from "./components/Layout";
import NetworkSwitcher from "./components/NetworkSwitcher";
import HomePage from "./pages/HomePage";
import MyNFTsPage from "./pages/MyNFTsPage";
import MintNFTPage from "./pages/MintNFTPage";
import DashboardPage from "./pages/DashboardPage";

function OwnerRoute({ children }: { children: React.ReactNode }) {
  const { isOwner } = useWallet();
  return isOwner ? <>{children}</> : <Navigate to="/" replace />;
}

function App() {
  return (
    <WalletProvider>
      <Router>
        <Layout>
          <NetworkSwitcher />
          <Routes>
            <Route path="/"          element={<HomePage />} />
            <Route path="/my-nfts"   element={<MyNFTsPage />} />
            <Route path="/create"    element={<OwnerRoute><MintNFTPage /></OwnerRoute>} />
            <Route path="/dashboard" element={<DashboardPage />} />
          </Routes>
        </Layout>
      </Router>
    </WalletProvider>
  );
}

export default App;
